import {
  exportarRelatorioFinanceiro,
  exportarChecklistPDF,
  exportarDiarioPDF,
} from '@services/backup.js'

export const EXPORT_RELATORIOS = [
  {
    titulo: 'Financeiro completo',
    desc: 'PDF com gastos e categorias',
    fn: exportarRelatorioFinanceiro,
  },
  {
    titulo: 'Checklist da obra',
    desc: 'PDF com etapas e status da jornada',
    fn: exportarChecklistPDF,
  },
  {
    titulo: 'Diário de bordo',
    desc: 'PDF com anotações, clima, equipe e fotos',
    fn: () => exportarDiarioPDF(),
  },
] as const
